<template>
  <section class="cookies-page">
    <!-- Hero Section -->
    <div class="cookies-hero">
      <div class="hero-content">
        <h1 class="hero-title">
          {{ $t?.('cookies.title') || 'Política de Cookies' }}
        </h1>
        <p class="hero-subtitle">
          {{ $t?.('cookies.subtitle') || 'Información sobre o uso de cookies neste sitio web' }}
        </p>
      </div>
    </div>

    <!-- Content Section -->
    <div class="cookies-content section">
      <div class="container">
        <Card variant="elevated" padding="lg" class="content-card">
          <div class="legal-content">
            
            <!-- Información Inicial -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.infoTitle') || 'Información sobre Cookies' }}</h2>
              <div class="section-text" v-html="$t?.('cookies.infoText') || ''"></div>
            </div>

            <!-- ¿Qué son las cookies? -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.whatTitle') || '¿Que son as cookies?' }}</h2>
              <div class="section-text" v-html="$t?.('cookies.whatText1') || ''"></div>
              <div class="section-text" v-html="$t?.('cookies.whatText2') || ''"></div>
            </div>

            <!-- Cookies afectadas -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.affectedTitle') || 'Cookies Afectadas pola Normativa' }}</h2>
              <div class="section-text" v-html="$t?.('cookies.affectedText') || ''"></div>
            </div>

            <!-- Tipos de cookies -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.typesTitle') || 'Tipos de Cookies' }}</h2>
              
              <h3 class="subsection-title">{{ $t?.('cookies.purposeTitle') || 'Segundo a Finalidade' }}</h3>
              <ul class="cookies-list">
                <li><strong>Cookies técnicas e funcionais:</strong> {{ $t?.('cookies.technical') || '' }}</li>
                <li><strong>Cookies analíticas:</strong> {{ $t?.('cookies.analytical') || '' }}</li>
                <li><strong>Cookies publicitarias:</strong> {{ $t?.('cookies.advertising') || '' }}</li>
                <li><strong>Cookies de publicidade comportamental:</strong> {{ $t?.('cookies.behavioral') || '' }}</li>
                <li><strong>Cookies sociais:</strong> {{ $t?.('cookies.social') || '' }}</li>
                <li><strong>Cookies de afiliados:</strong> {{ $t?.('cookies.affiliate') || '' }}</li>
                <li><strong>Cookies de seguridade:</strong> {{ $t?.('cookies.security') || '' }}</li>
              </ul>

              <h3 class="subsection-title">{{ $t?.('cookies.ownershipTitle') || 'Segundo a Propiedade' }}</h3>
              <ul class="cookies-list">
                <li><strong>Cookies propias:</strong> {{ $t?.('cookies.own') || '' }}</li>
                <li><strong>Cookies de terceiros:</strong> {{ $t?.('cookies.thirdParty') || '' }}</li>
              </ul>

              <h3 class="subsection-title">{{ $t?.('cookies.durationTitle') || 'Segundo o Prazo de Conservación' }}</h3>
              <ul class="cookies-list">
                <li><strong>Cookies de sesión:</strong> {{ $t?.('cookies.session') || '' }}</li>
                <li><strong>Cookies persistentes:</strong> {{ $t?.('cookies.persistent') || '' }}</li>
              </ul>
            </div>

            <!-- Cookies utilizadas -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.usedTitle') || 'Cookies Utilizadas neste Sitio Web' }}</h2>
              
              <!-- Cookies controladas por el editor -->
              <h3 class="subsection-title">{{ $t?.('cookies.controlledTitle') || 'Cookies Controladas polo Editor' }}</h3>
              
              <h4 class="cookie-category">{{ $t?.('cookies.technicalTitle') || 'Técnicas e funcionais' }}</h4>
              <div class="table-wrapper">
                <table class="cookies-table">
                  <thead>
                    <tr>
                      <th>{{ $t?.('cookies.tableProperty') || 'Propiedade' }}</th>
                      <th>{{ $t?.('cookies.tableCookie') || 'Cookie' }}</th>
                      <th>{{ $t?.('cookies.tablePurpose') || 'Finalidade' }}</th>
                      <th>{{ $t?.('cookies.tableDuration') || 'Prazo' }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>google.com</td>
                      <td>__Secure-ENID</td>
                      <td>{{ $t?.('cookies.googleSecurePurpose') || 'Cookie necesaria para a utilización das opcións e servizos do sitio web' }}</td>
                      <td>5 meses</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h4 class="cookie-category">{{ $t?.('cookies.advertisingTitle') || 'Publicitarias' }}</h4>
              <div class="table-wrapper">
                <table class="cookies-table">
                  <thead>
                    <tr>
                      <th>{{ $t?.('cookies.tableProperty') || 'Propiedade' }}</th>
                      <th>{{ $t?.('cookies.tableCookie') || 'Cookie' }}</th>
                      <th>{{ $t?.('cookies.tablePurpose') || 'Finalidade' }}</th>
                      <th>{{ $t?.('cookies.tableDuration') || 'Prazo' }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Google</td>
                      <td>NID</td>
                      <td>{{ $t?.('cookies.googleNIDPurpose') || 'Estas cookies utilízanse para recompilar estadísticas do sitio web e rastrear as taxas de conversión e a personalización de anuncios de Google' }}</td>
                      <td>7 meses</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Cookies de terceros -->
              <h3 class="subsection-title">{{ $t?.('cookies.thirdPartyTitle') || 'Cookies de Terceiros' }}</h3>
              <div class="section-text" v-html="$t?.('cookies.thirdPartyText') || ''"></div>
              
              <div class="info-box">
                <h4>{{ $t?.('cookies.externalProvidersTitle') || 'Provedores externos deste sitio web:' }}</h4>
                <div class="table-wrapper">
                  <table class="cookies-table">
                    <thead>
                      <tr>
                        <th>{{ $t?.('cookies.tableEditor') || 'Editor' }}</th>
                        <th>{{ $t?.('cookies.tablePrivacyPolicy') || 'Política de privacidade' }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Google</td>
                        <td><a href="https://privacy.google.com/take-control.html" target="_blank" rel="noopener noreferrer">https://privacy.google.com/take-control.html</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Panel de configuración -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.panelTitle') || 'Panel de Configuración de Cookies' }}</h2>
              <div class="section-text" v-html="$t?.('cookies.panelText') || ''"></div>
              <div class="panel-link-wrapper">
                <Button variant="primary" size="md" @click="openCookiePanel">
                  <i class="fas fa-cog"></i>
                  {{ $t?.('cookies.panelButton') || 'Panel de cookies' }}
                </Button>
              </div>
            </div>

            <!-- Gestionar desde el navegador -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.manageTitle') || 'Como Xestionar as Cookies desde o Navegador' }}</h2>
              
              <h3 class="subsection-title">{{ $t?.('cookies.deleteTitle') || 'Eliminar as cookies do dispositivo' }}</h3>
              <div class="section-text" v-html="$t?.('cookies.deleteText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('cookies.specificTitle') || 'Xestionar as cookies específicas do sitio' }}</h3>
              <div class="section-text" v-html="$t?.('cookies.specificText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('cookies.blockTitle') || 'Bloquear as cookies' }}</h3>
              <div class="section-text" v-html="$t?.('cookies.blockText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('cookies.browserTitle') || 'Como eliminar as cookies dos navegadores máis comúns' }}</h3>
              <div class="browser-links">
                <a href="http://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer" class="browser-link">
                  <i class="fab fa-chrome"></i> Chrome
                </a>
                <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" class="browser-link">
                  <i class="fab fa-edge"></i> Edge
                </a>
                <a href="https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer" target="_blank" rel="noopener noreferrer" class="browser-link">
                  <i class="fab fa-internet-explorer"></i> Explorer
                </a>
                <a href="https://www.mozilla.org/es-ES/privacy/websites/#cookies" target="_blank" rel="noopener noreferrer" class="browser-link">
                  <i class="fab fa-firefox"></i> Firefox
                </a>
                <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" class="browser-link">
                  <i class="fab fa-safari"></i> Safari
                </a>
                <a href="https://help.opera.com/en/latest/security-and-privacy/#clearBrowsingData" target="_blank" rel="noopener noreferrer" class="browser-link">
                  <i class="fab fa-opera"></i> Opera
                </a>
              </div>
            </div>

            <!-- Tratamiento de datos personales -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('cookies.dataTitle') || 'Tratamento de Datos Persoais' }}</h2>
              <div class="section-text" v-html="$t?.('cookies.dataText1') || ''"></div>
              <ul class="data-list">
                <li><strong>{{ $t?.('cookies.dataPurpose') || 'Fins do tratamento:' }}</strong> {{ $t?.('cookies.dataPurposeText') || '' }}</li>
                <li><strong>{{ $t?.('cookies.dataLegitimation') || 'Lexitimación do tratamento:' }}</strong> {{ $t?.('cookies.dataLegitimationText') || '' }}</li>
                <li><strong>{{ $t?.('cookies.dataRetention') || 'Criterios de conservación dos datos:' }}</strong> {{ $t?.('cookies.dataRetentionText') || '' }}</li>
                <li><strong>{{ $t?.('cookies.dataCommunication') || 'Comunicación dos datos:' }}</strong> {{ $t?.('cookies.dataCommunicationText') || '' }}</li>
              </ul>

              <h3 class="subsection-title">{{ $t?.('cookies.rightsTitle') || 'Dereitos que asisten ao Interesado:' }}</h3>
              <ul class="rights-list">
                <li>{{ $t?.('cookies.rightWithdraw') || 'Dereito a retirar o consentimento en calquera momento.' }}</li>
                <li>{{ $t?.('cookies.rightAccess') || 'Dereito de acceso, rectificación, portabilidade e supresión dos seus datos, e de limitación ou oposición ao seu tratamento.' }}</li>
                <li>{{ $t?.('cookies.rightComplaint') || 'Dereito a presentar unha reclamación ante a Autoridade de control (www.aepd.es) se considera que o tratamento non se axusta á normativa vixente.' }}</li>
              </ul>

              <div class="contact-box">
                <h4>{{ $t?.('cookies.contactTitle') || 'Datos de contacto para exercer os seus dereitos:' }}</h4>
                <p><strong>Banda de Música de Noia</strong></p>
                <p>Rúa Vizconde de San Alberto, s/n - 15200 Noia</p>
                <p>
                  <strong>Email:</strong> 
                  <a href="#" @click.prevent="copyEmail" class="email-link">
                    bandadenoia<span class="email-separator"> [arroba] </span>gmail.com
                  </a>
                  <span class="email-hint">(Click para copiar)</span>
                </p>
              </div>
            </div>

            <!-- Last Update -->
            <div class="last-update">
              <i class="fas fa-calendar-alt"></i>
              {{ $t?.('cookies.lastUpdate') || 'Última actualización' }}: {{ currentDate }}
            </div>
          </div>
        </Card>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import { useHead } from '@vueuse/head';
import Card from '../ui/Card.vue';
import Button from '../ui/Button.vue';
import { buildHeadConfig, getBreadcrumbJsonLd } from '../../seo/meta';

// Access i18n
const instance = getCurrentInstance();
const $t = instance?.appContext.config.globalProperties.$t;

useHead(
  buildHeadConfig('cookies', {
    jsonLd: [getBreadcrumbJsonLd('cookies')],
  }),
)

// Current date for last update
const currentDate = computed(() => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  return `${day}-${month}-${year}`;
});

// Copy email function
const copyEmail = async () => {
  const email = 'bandadenoia@gmail.com';
  try {
    await navigator.clipboard.writeText(email);
    alert('✓ Email copiado ao portapapeis!');
  } catch (err) {
    const textArea = document.createElement('textarea');
    textArea.value = email;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    alert('✓ Email copiado ao portapapeis!');
  }
};

// Open cookie panel (this would trigger the CookieConsent component)
const openCookiePanel = () => {
  // Emit event to parent to show cookie consent
  const event = new CustomEvent('show-cookie-panel');
  window.dispatchEvent(event);
};
</script>

<style scoped>
/* Cookies Page */
.cookies-page {
  background: white;
}

/* Hero Section */
.cookies-hero {
  position: relative;
  min-height: 35vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-band);
  overflow: hidden;
  padding: var(--spacing-16) var(--spacing-4);
}

.cookies-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: var(--font-weight-bold);
  color: white;
  margin-bottom: var(--spacing-4);
  font-family: var(--font-family-serif);
  line-height: 1.1;
  text-align: center;
}

.hero-subtitle {
  font-size: clamp(1rem, 2.5vw, 1.25rem);
  color: rgba(255, 255, 255, 0.95);
  font-weight: var(--font-weight-medium);
  text-align: center;
}

/* Content Section */
.cookies-content {
  padding: var(--spacing-20) 0;
  background: var(--color-neutral-50);
}

.content-card {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--spacing-6);
}

.legal-content {
  color: var(--color-text-primary);
  line-height: 1.8;
  padding: var(--spacing-8);
}

/* Sections */
.legal-section {
  margin-bottom: var(--spacing-12);
  padding-bottom: var(--spacing-8);
  border-bottom: 1px solid var(--color-neutral-200);
}

.legal-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
}

.section-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-primary-700);
  margin: 0 0 var(--spacing-6) 0;
  font-family: var(--font-family-serif);
}

.subsection-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-primary-600);
  margin: var(--spacing-6) 0 var(--spacing-4) 0;
  font-family: var(--font-family-serif);
}

.cookie-category {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-secondary-600);
  margin: var(--spacing-4) 0 var(--spacing-3) 0;
  background: var(--color-secondary-50);
  padding: var(--spacing-3) var(--spacing-4);
  border-radius: var(--border-radius-md);
  border-left: 4px solid var(--color-secondary-500);
}

.section-text {
  margin-bottom: var(--spacing-4);
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  text-align: justify;
  line-height: 1.8;
}

/* Lists */
.cookies-list, .data-list, .rights-list {
  list-style: none;
  padding: 0;
  margin: var(--spacing-4) 0;
}

.cookies-list li, .data-list li, .rights-list li {
  padding: var(--spacing-3) 0 var(--spacing-3) var(--spacing-8);
  border-left: 3px solid var(--color-primary-200);
  margin-bottom: var(--spacing-3);
  position: relative;
}

.cookies-list li::before, .data-list li::before, .rights-list li::before {
  content: '●';
  position: absolute;
  left: var(--spacing-3);
  color: var(--color-primary-500);
  font-size: 0.8em;
}

.cookies-list li strong {
  color: var(--color-primary-700);
}

/* Tables */
.table-wrapper {
  overflow-x: auto;
  margin: var(--spacing-4) 0;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
}

.cookies-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: var(--font-size-sm);
}

.cookies-table thead {
  background: var(--gradient-music);
  color: white;
}

.cookies-table th {
  padding: var(--spacing-5) var(--spacing-6);
  text-align: left;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
}

.cookies-table td {
  padding: var(--spacing-4) var(--spacing-6);
  border-bottom: 1px solid var(--color-neutral-200);
  color: var(--color-text-secondary);
}

.cookies-table tbody tr:last-child td {
  border-bottom: none;
}

.cookies-table tbody tr:hover {
  background: var(--color-neutral-50);
}

.cookies-table a {
  color: var(--color-primary-600);
  text-decoration: none;
  word-break: break-all;
}

.cookies-table a:hover {
  text-decoration: underline;
}

/* Info Box */
.info-box {
  background: var(--color-primary-50);
  border: 1px solid var(--color-primary-200);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-6);
  margin: var(--spacing-6) 0;
}

.info-box h4 {
  margin: 0 0 var(--spacing-4) 0;
  color: var(--color-primary-700);
  font-weight: var(--font-weight-semibold);
}

/* Contact Box */
.contact-box {
  background: var(--color-neutral-50);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-6);
  margin: var(--spacing-10) 0;
  border-left: 4px solid var(--color-primary-500);
}

.contact-box h4 {
  margin: 0 0 var(--spacing-4) 0;
  color: var(--color-primary-700);
  font-weight: var(--font-weight-semibold);
}

.contact-box p {
  margin: var(--spacing-2) 0;
  color: var(--color-text-secondary);
}

.email-link {
  color: var(--color-primary-600);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}

.email-link:hover {
  text-decoration: underline;
}

.email-separator {
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-normal);
}

.email-hint {
  display: inline-block;
  margin-left: var(--spacing-2);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  font-style: italic;
}

/* Panel Link */
.panel-link-wrapper {
  margin: var(--spacing-6) 0;
  text-align: center;
}

/* Browser Links */
.browser-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--spacing-4);
  margin: var(--spacing-6) 0;
}

.browser-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-4);
  background: white;
  border: 2px solid var(--color-neutral-300);
  border-radius: var(--border-radius-lg);
  color: var(--color-text-primary);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  transition: all var(--duration-fast);
}

.browser-link:hover {
  border-color: var(--color-primary-500);
  background: var(--color-primary-50);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.browser-link i {
  font-size: 1.25rem;
  color: var(--color-primary-600);
}

/* Last Update */
.last-update {
  margin-top: var(--spacing-10);
  padding: var(--spacing-4) var(--spacing-6);
  background: rgba(79, 148, 160, 0.1);
  border-left: 4px solid var(--color-primary-500);
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-sm);
  color: var(--color-primary-700);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  font-weight: var(--font-weight-medium);
}

.last-update i {
  color: var(--color-primary-500);
}

/* Responsive */
@media (max-width: 768px) {
  .cookies-hero {
    min-height: 30vh;
  }

  .section-title {
    font-size: var(--font-size-xl);
  }

  .subsection-title {
    font-size: var(--font-size-lg);
  }

  .section-text {
    text-align: left;
  }

  .cookies-table {
    font-size: var(--font-size-xs);
  }

  .cookies-table th,
  .cookies-table td {
    padding: var(--spacing-2) var(--spacing-3);
  }

  .browser-links {
    grid-template-columns: 1fr;
  }
}

/* Refresh 2026 - visual coherence with Home */
.cookies-page {
  background: transparent;
}

.cookies-hero {
  min-height: 40vh;
  padding: clamp(2.4rem, 5.4vw, 4.3rem) var(--spacing-4);
  background:
    radial-gradient(circle at 84% 14%, rgba(219, 174, 80, 0.2), rgba(219, 174, 80, 0) 42%),
    linear-gradient(132deg, #10293b 0%, #1a3c54 52%, #2f6285 100%);
}

.cookies-hero::before {
  background: radial-gradient(circle at 18% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 45%);
}

.cookies-content {
  background: transparent;
}

.content-card {
  background: var(--surface-card-strong);
  border: 1px solid rgba(16, 41, 59, 0.12);
  box-shadow: var(--shadow-xl);
}

.cookie-category,
.info-box,
.contact-box {
  background: rgba(255, 255, 255, 0.76);
  border-color: rgba(16, 41, 59, 0.12);
}

.cookies-table {
  background: rgba(255, 255, 255, 0.9);
}

.cookies-table thead {
  background: linear-gradient(132deg, #173c56 0%, #2f6285 55%, #a77123 100%);
}

.browser-link {
  background: rgba(255, 255, 255, 0.82);
  border-color: rgba(16, 41, 59, 0.16);
}

.browser-link:hover {
  border-color: rgba(167, 113, 35, 0.44);
  background: rgba(219, 174, 80, 0.12);
}

.last-update {
  background: rgba(26, 79, 113, 0.12);
}
</style>
